import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
/**
 * A DatePicker Selector
 *
 * @param	{string}		placeholderText	Placeholder Text
 * @param {string}		className		css class name
 **/

var Picker = /*#__PURE__*/function (_React$Component) {
  _inherits(Picker, _React$Component);

  function Picker(props) {
    var _this;

    _classCallCheck(this, Picker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Picker).call(this, props));
    _this.state = {
      startDate: ''
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Picker, [{
    key: "handleChange",
    value: function handleChange(date) {
      this.setState({
        startDate: date
      });

      if (this.props.inputChanged) {
        this.props.inputChanged(date);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(DatePicker, Object.assign({}, this.props.customInput ? {
        customInput: this.props.customInput
      } : {}, this.props.id ? {
        id: this.props.id
      } : {}, {
        dateFormat: "dd.MM.yyyy",
        placeholderText: this.props.placeholderText,
        selected: this.state.startDate,
        onChange: this.handleChange,
        className: this.props.className,
        minDate: this.props.minDate
      }));
    }
  }]);

  return Picker;
}(React.Component);

export default Picker;